import { createSelector } from 'reselect';

const getRedoStack = ({ designPro }) => designPro.undo.redoStack;
const getUndoStack = ({ designPro }) => designPro.undo.undoStack;
const isOperationInProgress = ({ designPro }) =>
  designPro.undo.isOperationInProgress;
const nextRedoAction = ({ designPro }) => designPro.undo.redoStack[0];
const nextUndoAction = ({ designPro }) => designPro.undo.undoStack[0];
const redoHasValues = ({ designPro }) => designPro.undo.redoStack.length > 0;
const undoHasValues = ({ designPro }) => designPro.undo.undoStack.length > 0;

const isUndoEnabled = createSelector(
  isOperationInProgress,
  undoHasValues,
  (isInProgress, canUndo) => !(isInProgress || !canUndo),
);

const isRedoEnabled = createSelector(
  isOperationInProgress,
  redoHasValues,
  (isInProgress, canRedo) => !(isInProgress || !canRedo),
);

export default {
  getRedoStack,
  getUndoStack,
  isOperationInProgress,
  isRedoEnabled,
  isUndoEnabled,
  nextRedoAction,
  nextUndoAction,
};
